module.exports = __webpack_public_path__ + "static/business-features-5aa2cb4debe0f3410a95b88f5ac87761.jpg";